import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthContext";
import { api } from "../lib/api";

const PortalParticipantsContext = createContext(null);

export function PortalParticipantsProvider({ children }) {
  const { client, user } = useAuth();
  const [participants, setParticipants] = useState(null);

  useEffect(() => {
    if (!client?.id) {
      setParticipants(null);
      return undefined;
    }
    let alive = true;
    const params = user?.role === "admin" ? `?client_id=${client.id}` : "";
    api
      .get(`/portal/participants${params}`)
      .then(({ data }) => {
        if (alive) setParticipants(data);
      })
      .catch(() => {
        if (alive) setParticipants(null);
      });
    return () => {
      alive = false;
    };
  }, [client?.id, user?.role]);

  return (
    <PortalParticipantsContext.Provider value={participants}>
      {children}
    </PortalParticipantsContext.Provider>
  );
}

export function usePortalParticipants() {
  return useContext(PortalParticipantsContext);
}
